module.exports = __webpack_public_path__ + "static/media/horizontal_flower.871b6901.svg";